"use client";
import { sendGTMEvent } from "@next/third-parties/google";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const GTMPageView = () => {
  const pathname = usePathname();

  useEffect(() => {
    sendGTMEvent({
      event: "page_view",
      page_title: document.title,
      page_location: window.location.href,
      page_path: pathname,
    });
  }, [pathname]);

  return null;
};

export default GTMPageView;
